import React, { Component } from 'react';
import UserModule from './UserModule';
import { ItemTypes, PanelTypes, ModuleTypes } from '../../constants/sidebar/DragAndDropTypes';
import { DropTarget } from 'react-dnd';
import { connect } from 'react-redux'
import { moveInModule, moveOutModule } from '../../actions/sidebar'

@connect(state => ({
}), dispatch => ({
    handleMoveInModule: (targetName, index, module) => {
        dispatch(moveInModule(targetName, index, module))
    },
    handleMoveOutModule: (panelName, moduleId) => {
        dispatch(moveOutModule(panelName, moduleId))
    }
}))
@DropTarget(ItemTypes.MODULE, {
    drop(props, monitor, component) {
    },
    hover(props, monitor, component) {

        const draggingItem = monitor.getItem();
        const hoverIndex = component.props.modules.length;

        // 자기 자신의 위에 있으면 hover 처리 하지 않음
        if(component.props.modules.findIndex((module) => module.moduleId === draggingItem.module.moduleId) !== -1){
            return;
        }

        component.handleMoveIn(draggingItem, hoverIndex, draggingItem.from);
    }
}, (connect, monitor) => {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop()
    };
})
class UserPanel extends Component {

    constructor(props){
        super(props);

        this.handleMoveIn = this.handleMoveIn.bind(this);
        this.handleMoveOut = this.handleMoveOut.bind(this);
    }

    handleMoveIn(draggingItem, hoverIndex, from) {

        const { handleMoveInModule } = this.props;

        let thisPanelIdx = PanelTypes.USER;

        handleMoveInModule(thisPanelIdx, 0, draggingItem.module);
        draggingItem.moveFromPanel(draggingItem.module.moduleId); // 기존에 모듈이 들어 있던 패널에서 제거.

        draggingItem.from = thisPanelIdx; // 패널 아이디 갱신
        draggingItem.index = 0; // index 갱신
        draggingItem.moveFromPanel = this.handleMoveOut; // 다른 패널로 이동시에 기존에서 제거할 메소드 재할당

    }

    handleMoveOut(moduleId){
        const { handleMoveOutModule } = this.props;
        handleMoveOutModule(PanelTypes.USER, moduleId);
    }

    render() {
        const { sidebarCount } = this.props;
        const { modules } = this.props;
        return (
            <div className="wrap_order">
                <strong className="tit_set">사용자 모듈</strong>
                <div className="list_order">
                    { modules.map((module, index) => <UserModule key={module.moduleId}
                                                                  index={index}
                                                                  module={module}
                                                                  sidebarCount={sidebarCount}
                                                                  panelIndex={PanelTypes.USER}
                                                                  moveIn={this.handleMoveIn}
                                                                  moveOut={this.handleMoveOut}
                    />)
                    }
                </div>
            </div>
        );
    }
}

export default UserPanel;
